<template>
  <div
    id="print-server-alert-modal"
    class="print-server-alert-modal"
  >
    <modal
      ref="printServerAlertModal"
      template="neutral"
      title="Atualização Importante"
      ref-name="printServerAlertModal"
      :icon-enabled="false"
      :close-button-enabled="false"
      class="print-server-alert-modal"
      @open="handleOpen"
      @close="handleClose"
    >
      <button class="print-server-alert-modal__timer-button">
        <span v-if="timer > 0"> {{ timer }}</span>
        <svg
          v-else
          class="icon"
          viewBox="0 0 24 24"
          @click="closePrintServerAlertModal()"
        >
          <title>Fechar modal de alerta sobre sistema de impressão</title>
          <g
            fill="none"
            stroke="currentColor"
            stroke-miterlimit="10"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line
              x1="3"
              y1="3"
              x2="21"
              y2="21"
            />
            <line
              x1="21"
              y1="3"
              x2="3"
              y2="21"
            />
          </g>
        </svg>
      </button>

      <p>
        Prezado cliente, <br>
        Realizamos uma atualização de segurança do nosso sistema de impressão de etiquetas. Solicitamos que realize a
        atualização clicando no link abaixo para download. <br>
        Siga o passo-a-passo conforme vídeo e em caso de dúvidas, por favor entre em contato.
      </p>

      <md-layout
        class="new"
        md-flex="100"
      >
        <video
          v-if="isModalOpen"
          width="800"
          controls
          preload="metadata"
          @loadedmetadata="onVideoLoaded"
        >
          <source
            src="https://storageapoiob2bprd.blob.core.windows.net/dashboard/UpdatePrinterClient.mp4"
            type="video/mp4"
          >
          Seu navegador não suporta vídeos em HTML5. Atualize para uma versão mais recente.
        </video>
      </md-layout>

      <div class="print-server-alert-modal__actions">
        <md-button
          class="btn btn-primary"
          @click="downloadFile()"
        >
          Download do Novo Sistema de Impressão
        </md-button>
      </div>

      <hr>

      <div class="print-server-alert-modal__footer new">
        <span>Agradecemos sua compreensão.</span>
        <span>Atenciosamente,</span>
        <span>TI Apoio Alvaro</span>
        <a href="tel:+08006438100"> 0800 643 8100 </a>
        <a
          href="mailto:ti.alvaroapoio@dasa.com.br?subject=Sistema de Impressão&body=Olá, tenho dúvidas sobre o novo sistema de impressao!"
        >
          ti.alvaroapoio@dasa.com.br
        </a>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: 'PrintServerAlertModal',
  data: () => {
    return {
      firstTimeAtNewDashboard: false,
      timer: 15,
      intervalId: null,
      isModalOpen: false
    }
  },
  mounted() {
    this.iniciarTimer()
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  },
  methods: {
    onVideoLoaded(event) {
      const video = event.target
      video.currentTime = 1
    },
    openPrintServerAlertModal() {
      this.$refs.printServerAlertModal.open()
    },
    closePrintServerAlertModal() {
      this.$refs.printServerAlertModal.close()
      localStorage.setItem('printServerAviso', true)
    },
    iniciarTimer() {
      this.intervalId = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        } else {
          clearInterval(this.intervalId)
        }
      }, 1000)
    },
    downloadFile() {
      window.location =
        'https://storageapoiob2bprd.blob.core.windows.net/printer-client-binaries-xp/Alvaro_windows_1_0_0.exe'
    },
    handleOpen() {
      this.isModalOpen = true
    },
    handleClose() {
      this.isModalOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.print-server-alert-modal {
  font-family: 'Exo 2', sans-serif !important;

  &__timer-button {
    width: 40px;
    height: 40px;
    position: fixed;
    top: 30px;
    right: 30px;
    z-index: 1041;
    background-color: #7f1a55;
    display: flex;
    flex-shrink: 0;
    border-radius: 50%;
    outline: none;
    transition: all ease 0.2s;
    padding: 0;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-family: 'Exo 2', sans-serif !important;
    font-weight: 300;

    svg {
      display: block;
      margin: auto;
      width: 20px;
    }
  }

  &__actions {
    display: flex;
    justify-content: center;
    margin: 20px 0;
  }

  &__footer {
    font-size: 14px;
    align-items: center;
  }

  .md-dialog {
    width: 810px;
    max-height: 90%;

    .size-medium .md-dialog {
      min-height: 140px;
    }

    .standard-modal__container-dismiss {
      margin-top: 12px;
    }

    .standard-modal__title {
      font-weight: 300;
      font-size: 34px;
      line-height: 26px;
      color: #7f1a54;
      font-family: 'Exo 2', sans-serif !important;
    }

    p {
      font-size: 14px;
      line-height: 20px;
      color: #7a7a7a;
    }

    .new {
      display: flex;
      flex-direction: column;
    }

    hr {
      border: 1px solid #d8d8d8;
      margin: 12px 0;
    }
  }

  video {
    margin-top: 12px;
  }
}

#printServerAlertModal {
  z-index: 1000;
}
</style>
